import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/defaults/tenant.defaults.mutation.gql"
import type {
  TenantDefaultsMutation,
  TenantDefaultsMutationVariables,
} from "@/v2-backoffice-client/tenant/defaults/__types__/tenant.defaults.mutation"

type Options = MutationHookOptions<
  TenantDefaultsMutation,
  TenantDefaultsMutationVariables
>

export function useTenantDefaultsMutation(options?: Options) {
  return useMutation<TenantDefaultsMutation, TenantDefaultsMutationVariables>(
    mutation,
    options,
  )
}
